module.exports = __webpack_public_path__ + "static/img/refImg@2x.1a9628b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/refImg@2x.png
// module id = AgdQ
// module chunks = 1